/* src/app/warehousing/pages/storage-charges/storage-charges.component.scss */
.chargesTable {
  background: white;
  border-radius: 4px;
  overflow-x: auto;
}
.num {
  text-align: right;
  white-space: nowrap;
}
/*# sourceMappingURL=storage-charges.component.css.map */
